/* tslint:disable */

import React from "react"

const PlayIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M8 5v14l11-7z" fill="white" />
      </svg>
    </div>
  )
}

export default PlayIcon
